interface ProfessionalPosition {
  completed_onboarding_at: string | null;
}

interface Professional {
  professional_positions?: ProfessionalPosition[];
}

interface CurrentUser {
  professional?: Professional;
}

export function hasOnboardedPosition(user: CurrentUser | undefined): boolean {
  return !!user?.professional?.professional_positions?.some(
    ({ completed_onboarding_at }) => completed_onboarding_at !== null,
  );
}
